
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"phone-call"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.7 14.483c-.45-.367-.942-.7-1.425-1.033-.958-.675-1.833-.725-2.55.358a1.109 1.109 0 01-1.558.358 6.883 6.883 0 01-3.592-3.5 1.358 1.358 0 01.442-1.9 1.342 1.342 0 00.766-1.191C6.742 6.8 4.858 4.242 4.117 3.933a1.333 1.333 0 00-.934 0c-8.941 3.242 8.642 22.25 12.55 12.5.375-1.05-.408-1.466-1.033-1.966v.016zm4.559-5.091A12.242 12.242 0 0010.834.958M9.025 6.425a5.175 5.175 0 014.767 4.758m2.791-.791a8.717 8.717 0 00-6.666-6.734m3.875 7.525a5.175 5.175 0 00-4.767-4.758","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    